/* sugar:assets/global.js@2.3.3 */
/*
 * One click on Add to cart is one add-to-cart.
 *
 * Every engine that rides along with a buy (Offer gifts and add-ons, Gift List, Gift Unlocks,
 * Gift Picker, Product Upsells, Bundle Builder) folds its lines into the same /cart/add request
 * as the product the shopper is buying. Shopify's storefront reports one add-to-cart per line in
 * that request, so a product with three gifts reads as four add-to-carts to every marketing
 * pixel, and a merchant can no longer count clicks. This splits the request: everything except
 * the product itself goes out first through a plain fetch from a hidden frame, then the product
 * goes out as the normal request and is the only line attributed. The caller gets the product's
 * response, whose rendered sections already include the rest. The product is the first line
 * that carries no gift marker; a request made only of gifts is attributed to nothing. A request
 * with a nested line (parent_id) is never split.
 * Paid lines and gifts go in separate frame requests: paid lines must land or the request goes
 * out whole as asked, while a gift that cannot be added is simply left out.
 */
(function () {
  if (window.__sugarGiftLinesSplit) return;
  window.__sugarGiftLinesSplit = true;
  var ADD_PATH = /^(?:\/[a-zA-Z]+(?:-[a-zA-Z]+)?)?\/+cart\/+add(?:\.js|\.json)?\/*$/;
  var frame = null;

  function isAddUrl(input) {
    try {
      var raw = typeof input === 'string' ? input : input && typeof input.url === 'string' ? input.url : '';
      var url = new URL(raw, window.location.href);
      return url.origin === window.location.origin && ADD_PATH.test(url.pathname);
    } catch (e) {
      return false;
    }
  }

  function isGiftLine(line) {
    var p = line && line.properties;
    if (!p || typeof p !== 'object') return false;
    if (p._gift_list === 'true' || p._gift_list === true) return true;
    if (p._gift_unlock === 'true' || p._gift_unlock === true) return true;
    if (Object.prototype.hasOwnProperty.call(p, '_gift_picker')) return true;
    return Object.prototype.hasOwnProperty.call(p, '_offer_gift');
  }

  // A fetch that no script on the page has wrapped: the one that belongs to a blank same-origin frame.
  function plainFetch() {
    if (!frame || !frame.isConnected) {
      frame = document.createElement('iframe');
      frame.setAttribute('aria-hidden', 'true');
      frame.setAttribute('tabindex', '-1');
      frame.style.cssText = 'display:none!important;width:0;height:0;border:0';
      (document.body || document.documentElement).appendChild(frame);
    }
    var win = frame.contentWindow;
    return win && typeof win.fetch === 'function' ? win.fetch.bind(win) : null;
  }

  function noop() {}

  // One cart line, as Shopify merges them: same variant, same selling plan, same properties.
  function lineKey(id, plan, props) {
    var p = props && typeof props === 'object' ? props : {};
    var names = Object.keys(p)
      .filter(function (n) {
        return p[n] !== '' && p[n] !== null && p[n] !== undefined;
      })
      .sort();
    return [String(id), plan ? String(plan) : '', names.map(function (n) { return n + '=' + String(p[n]); }).join('&')].join('|');
  }

  // How many of each line the cart holds, or null when the cart could not be read.
  function cartCounts(request) {
    return Promise.resolve(request)
      .then(function (r) {
        return r && r.ok ? r.json() : null;
      })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) return null;
        var counts = {};
        cart.items.forEach(function (item) {
          var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id;
          var key = lineKey(item.variant_id || item.id, plan, item.properties);
          counts[key] = (counts[key] || 0) + (Number(item.quantity) || 0);
        });
        return counts;
      })
      .catch(function () {
        return null;
      });
  }

  var wrapped = window.fetch;
  window.fetch = function (input, init) {
    var body = init && init.body;
    if (typeof body !== 'string' || !isAddUrl(input)) return wrapped.apply(this, arguments);
    var parsed;
    try {
      parsed = JSON.parse(body);
    } catch (e) {
      return wrapped.apply(this, arguments);
    }
    if (!parsed || !Array.isArray(parsed.items)) return wrapped.apply(this, arguments);
    // A line nested under another (parent_id, as bundle apps send free gifts) can only name its
    // parent by variant id while both are in the same request, so such a request goes out whole.
    if (parsed.items.some(function (line) { return line && line.parent_id != null && line.parent_id !== ''; })) {
      return wrapped.apply(this, arguments);
    }
    // The product, the paid lines riding along with it (a second set, an add-on, an upsell) and
    // the gifts. Each group goes out on its own so a gift that cannot be added never takes a paid
    // line with it: Shopify refuses a whole request when one of its lines cannot be added.
    var primary = null;
    var riders = [];
    var gifts = [];
    parsed.items.forEach(function (line) {
      if (isGiftLine(line)) gifts.push(line);
      else if (!primary) primary = line;
      else riders.push(line);
    });
    if (!riders.length && !gifts.length) return wrapped.apply(this, arguments);
    var quiet = plainFetch();
    if (!quiet) return wrapped.apply(this, arguments);

    var self = this;
    var args = arguments;
    var url;
    try {
      url = new URL(typeof input === 'string' ? input : input.url, window.location.href);
    } catch (e) {
      return wrapped.apply(this, arguments);
    }
    // The original request, untouched: every line in one go, the way it was asked for.
    function whole() {
      init.body = body;
      return wrapped.apply(self, args);
    }
    // The frame's own address is about:blank, so it is handed a full URL. A script that wraps the
    // frame's fetch too (Brave on iPhone does) and throws on the call turns the split off for this
    // add instead of stopping it: the original request goes out whole, as if nothing split it.
    function post(items, withSections) {
      var out = {};
      for (var key in init) if (Object.prototype.hasOwnProperty.call(init, key)) out[key] = init[key];
      var restBody = { items: items };
      if (withSections) {
        if (parsed.sections) restBody.sections = parsed.sections;
        if (parsed.sections_url) restBody.sections_url = parsed.sections_url;
      }
      out.body = JSON.stringify(restBody);
      return quiet(url.href, out);
    }
    function readCart() {
      var cartUrl = new URL(url.href);
      cartUrl.pathname = cartUrl.pathname.replace(/\/+cart\/+add(?:\.js|\.json)?\/*$/, '/cart.js');
      cartUrl.search = '';
      return quiet(cartUrl.href, { method: 'GET', credentials: 'same-origin', headers: { Accept: 'application/json' } });
    }
    // Gifts never block the purchase. When one of them cannot be added, the rest still go in,
    // one at a time.
    function sendGifts(first) {
      if (!gifts.length) return Promise.resolve();
      if (!first) {
        try {
          first = post(gifts);
        } catch (e) {
          return Promise.resolve();
        }
      }
      return Promise.resolve(first)
        .then(function (r) {
          if ((r && r.ok) || gifts.length < 2) return;
          return gifts.reduce(function (chain, gift) {
            return chain.then(function () {
              try {
                return Promise.resolve(post([gift])).then(noop, noop);
              } catch (e) {}
            });
          }, Promise.resolve());
        })
        .then(noop, noop);
    }
    // Rewrite the caller's own request object in place, so whatever wraps this fetch — in
    // either direction — reads the product line as the request that was made.
    function sendPrimary() {
      var primaryBody = {};
      for (var k in parsed) if (Object.prototype.hasOwnProperty.call(parsed, k)) primaryBody[k] = parsed[k];
      primaryBody.items = [primary];
      init.body = JSON.stringify(primaryBody);
      return wrapped.apply(self, args);
    }

    if (!primary) {
      // Nothing but gifts in this request (a picked gift, an unlocked gift): it is the whole
      // request, so it also renders the sections the caller asked for.
      try {
        return post(gifts, true);
      } catch (e) {
        return wrapped.apply(this, arguments);
      }
    }

    if (!riders.length) {
      var giftRequest;
      try {
        giftRequest = post(gifts);
      } catch (e) {
        return wrapped.apply(this, arguments);
      }
      return sendGifts(giftRequest).then(sendPrimary);
    }

    // Paid lines are part of what the shopper clicked for, so they must all land or the whole
    // request goes out as asked and the shopper sees Shopify's own answer. The cart is read first
    // so that a request whose answer never arrived can be told apart from one that was refused.
    var before;
    try {
      before = readCart();
    } catch (e) {
      return wrapped.apply(this, arguments);
    }
    return cartCounts(before).then(function (beforeCounts) {
      var riderRequest;
      try {
        riderRequest = post(riders);
      } catch (e) {
        return whole();
      }
      return Promise.resolve(riderRequest).then(
        function (r) {
          if (!r || !r.ok) return whole();
          return sendGifts().then(sendPrimary);
        },
        function () {
          var after;
          try {
            after = readCart();
          } catch (e) {
            return whole();
          }
          return cartCounts(after).then(function (afterCounts) {
            if (!beforeCounts || !afterCounts) return whole();
            var added = riders.some(function (line) {
              var key = lineKey(line.id || line.variant_id, line.selling_plan, line.properties);
              return (afterCounts[key] || 0) > (beforeCounts[key] || 0);
            });
            // Shopify adds all of a request or none of it: nothing new means it was refused.
            if (!added) return whole();
            return sendGifts().then(sendPrimary);
          });
        }
      );
    });
  };
})();

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}


function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button):not(.combined-localization__button):not(.combined-localization__close):not(.combined-localization__select):not(.combined-localization__select-option):not(.localization-bottom-sheet__trigger):not(.localization-bottom-sheet__option):not(.localization-bottom-sheet__close):not(.localization-bottom-sheet__tab)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      // Don't close if a bottom sheet (e.g., localization selector) is open
      if (this.dataset.bottomSheetOpen === 'true') return;

      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    // Only a submenu's own buttons close it. A button in content placed in the drawer (a tab, a
    // popup trigger, search) sits directly in the drawer and must not close it.
    if (!detailsElement || detailsElement === this.mainDetailsToggle) return;
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize, { passive: true });
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    if (this.header) this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }

      // Workaround for safari iframe bug
      const formerStyle = deferredElement.getAttribute('style');
      deferredElement.setAttribute('style', 'display: block;');
      window.setTimeout(() => {
        deferredElement.setAttribute('style', formerStyle);
      }, 0);
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    if (window.__swOk === false) { this.style.visibility = 'hidden'; return; }
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    // Ensure slidesPerPage is at least 1 to prevent incorrect totalPages calculation
    if (this.slidesPerPage < 1) this.slidesPerPage = 1;
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (window.__swOk === false) { this.querySelectorAll('select,input').forEach((n) => { n.disabled = true; }); this.setAttribute('hidden', ''); return; }
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options).forEach((option) => option.removeAttribute('selected'));
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const inputContainer = target.closest('.product-form__input, .variant-option');
      const selectedDropdownSwatchValue = inputContainer?.querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const inputContainer = target.closest('.product-form__input, .variant-option');
      const selectedSwatchValue = inputContainer?.querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    // A page can split a product's options across several pickers (a size picker, a
    // note, then a colour picker). Each <variant-selects> only holds its own option, so
    // the request is built from every picker of this section, ordered by option position;
    // otherwise the server answers with the first variant that merely matches one option.
    const byPosition = new Map();
    const collect = (root) => {
      Array.from(root.querySelectorAll('select, fieldset input:checked')).forEach((element) => {
        const id =
          element.tagName === 'SELECT'
            ? element.selectedOptions[0]?.dataset.optionValueId
            : element.dataset.optionValueId;
        if (!id) return;
        const holder = element.closest('[data-option-position]');
        const position = holder ? parseInt(holder.dataset.optionPosition, 10) : byPosition.size;
        const key = Number.isFinite(position) ? position : byPosition.size;
        if (!byPosition.has(key)) byPosition.set(key, id);
      });
    };
    collect(this);
    const section = this.dataset.section;
    if (section) {
      document.querySelectorAll(`variant-selects[data-section="${section}"]`).forEach((other) => {
        if (other !== this) collect(other);
      });
    }
    return Array.from(byPosition.keys())
      .sort((a, b) => a - b)
      .map((key) => byPosition.get(key));
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (html.querySelector('.sugar-layout-grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  static ASYNC_REQUEST_DELAY = 250;

  constructor() {
    super();
    this.queue = [];
    this.setRequestStarted(false);
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });

    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, BulkAdd.ASYNC_REQUEST_DELAY);
  }

  sendRequest(queue) {
    this.setRequestStarted(true);
    const items = {};

    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));

    this.updateMultipleQty(items);
  }

  setRequestStarted(requestStarted) {
    this._requestStarted = requestStarted;
  }

  get requestStarted() {
    return this._requestStarted;
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      event.target.setAttribute('value', inputValue);
      this.startQueue(index, inputValue);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

class CartPerformance {
  static #metric_prefix = "cart-performance"

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp
    });

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      startMarker.name,
      `${metricName}:end`
    );
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`);

    callback();

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }
}

/*
 * SugarIcon — JS mirror of snippets/icon.liquid for icons created at runtime
 * (cart badges, perk rows, timeline markers). Same token grammar, same CDN.
 * Emoji tokens need the Liquid lookup tables, so they fall back to the raw glyph.
 */
(function () {
  var script = document.currentScript || document.querySelector('script[src*="global.js"][data-cdn]');
  var BASE = (script && script.dataset && script.dataset.cdn) || '';
  var MASK = { hi: 1, si: 1, ph: 1, mdi: 1, care: 1, poi: 1, lab: 1, pict: 1, tabler: 1, lu: 1, sf: 1, sl: 1, solar: 1, game: 1, hero: 1, bi: 1, fluent: 1, iconpark: 1, gravity: 1, boxicons: 1, flex: 1, fas: 1, iconamoon: 1, emojione: 1 };
  var SETS = { ph: 'ph-', phosphor: 'ph-', healthicons: 'hi-', 'line-md': 'lmd-', 'simple-icons': 'si-', 'circle-flags': 'flag-', ginetex: 'care-', maki: 'poi-', temaki: 'poi-', 'lucide-lab': 'lab-', meteocons: 'weather-', 'fluent-emoji-high-contrast': 'pict-', tabler: 'tabler-', lucide: 'lu-', 'streamline-freehand': 'sf-', streamline: 'sl-', solar: 'solar-', 'game-icons': 'game-', heroicons: 'hero-', bi: 'bi-', mdi: 'mdi-', fluent: 'fluent-', 'icon-park-outline': 'iconpark-', 'gravity-ui': 'gravity-', boxicons: 'boxicons-', 'streamline-flex': 'flex-', 'fa7-solid': 'fas-', iconamoon: 'iconamoon-', 'emojione-monotone': 'emojione-', flagpack: 'flagpack-', 'flat-color-icons': 'flatcolor-' };
  var WEIGHT = { 100: '100', 200: '200', 300: '300', 400: '400', 500: '500', 600: '600', 700: '700' };

  function resolve(token) {
    var raw = String(token || '').trim();
    if (!raw) return null;
    if (raw.indexOf(':') !== -1) {
      var ip = raw.split(':');
      var set = ip[0].trim().toLowerCase();
      var nm = (ip[1] || '').trim().toLowerCase();
      if (set === 'flag') {
        raw = 'flag4x3-' + nm;
        var cut = raw.lastIndexOf('-4x3');
        if (cut !== -1) raw = raw.slice(0, cut) + raw.slice(cut + 4);
      } else if (SETS[set]) {
        raw = SETS[set] + nm;
      } else {
        var fill = false;
        if (set.indexOf('material-symbols') !== -1) {
          if (nm.indexOf('-outline') !== -1) nm = nm.replace('-outline', '');
          else fill = true;
          nm = nm.replace('-rounded', '').replace('-sharp', '');
        }
        raw = nm.replace(/-/g, '_') + (fill ? '-fill' : '') + (set === 'material-symbols-light' ? '-300' : '');
      }
    }
    var dashed = raw.toLowerCase().replace(/ /g, '-').replace(/['"()]/g, '');
    var seg = dashed.split('-');
    var family = '';
    if (seg.length > 1) {
      if (seg[0] === 'lmd' || seg[0] === 'sugar' || seg[0] === 'lottie') family = 'lmd';
      else if (MASK[seg[0]]) family = 'mask';
      else if (seg[0] === 'weather' || seg[0] === 'flag4x3' || seg[0] === 'flagpack' || seg[0] === 'flatcolor') family = 'img';
      else if (seg[0] === 'flag') {
        family = '';
        for (var i = 1; i < seg.length; i++) {
          if (!/^(100|200|300|400|500|600|700|fill|filled|opsz20|opsz24|opsz40|opsz48)$/.test(seg[i])) { family = 'img'; break; }
        }
      }
    }
    if (family) return { mode: family, url: BASE + dashed + '.svg' };
    if (/^\d{1,2}$/.test(seg[0])) {
      return { mode: 'number', text: seg[0], shape: seg.indexOf('circle') > 0 ? 'circle' : (seg.indexOf('square') > 0 ? 'square' : ''), fill: seg.indexOf('fill') > 0 || seg.indexOf('filled') > 0 };
    }
    if (!/^[a-z0-9_]/.test(dashed)) return { mode: 'text', text: raw.split('-')[0] };
    var parts = raw.toLowerCase().replace(/ /g, '_').replace(/['"()]/g, '').split('-');
    var name = parts[0];
    var weight = '400';
    var filled = false;
    var opticalSize = '48';
    for (var j = 1; j < parts.length; j++) {
      if (WEIGHT[parts[j]]) weight = WEIGHT[parts[j]];
      else if (parts[j] === 'fill' || parts[j] === 'filled') filled = true;
      else if (/^opsz(20|24|40|48)$/.test(parts[j])) opticalSize = parts[j].slice(4);
    }
    var up = name.split('_');
    for (var k = 0; k < 2 && up.length > 1; k++) {
      var last = up[up.length - 1];
      if (last === 'fill' || last === 'filled') { filled = true; up.pop(); }
      else if (WEIGHT[last]) { weight = WEIGHT[last]; up.pop(); }
      else break;
    }
    return { mode: 'mask', url: BASE + 'ms-' + up.join('_') + '--' + weight + (filled ? '-fill' : '') + (opticalSize !== '48' ? '-opsz' + opticalSize : '') + '.svg' };
  }

  function numRect(NS, fill, rx) {
    var rect = document.createElementNS(NS, 'rect');
    rect.setAttribute('class', 'sugar-icon-number__shape');
    rect.setAttribute('width', '24');
    rect.setAttribute('height', '24');
    rect.setAttribute('rx', rx);
    rect.setAttribute('ry', rx);
    rect.setAttribute('fill', fill);
    return rect;
  }

  function create(token, className) {
    var r = resolve(token);
    var el;
    if (!r) return document.createTextNode('');
    if (r.mode === 'text') {
      el = document.createElement('span');
      el.className = 'sugar-icon-emoji sugar-icon-emoji--native' + (className ? ' ' + className : '');
      el.textContent = r.text;
      return el;
    }
    if (r.mode === 'number') {
      var numCls = 'sugar-icon sugar-icon-number' + (String(r.text).length > 1 ? ' sugar-icon-number--two' : '') + (r.shape ? ' sugar-icon-number--' + r.shape : '');
      if (r.fill) {
        var NS = 'http://www.w3.org/2000/svg';
        var maskId = 'sic-' + r.text + (r.shape || '');
        var rx = r.shape === 'circle' ? 12 : 4;
        var svg = document.createElementNS(NS, 'svg');
        svg.setAttribute('class', numCls + ' sugar-icon-number--fill' + (className ? ' ' + className : ''));
        svg.setAttribute('viewBox', '0 0 24 24');
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('focusable', 'false');
        var mask = document.createElementNS(NS, 'mask');
        mask.setAttribute('id', maskId);
        mask.appendChild(numRect(NS, '#fff', rx));
        var digit = document.createElementNS(NS, 'text');
        digit.setAttribute('x', '12');
        digit.setAttribute('y', '12');
        digit.textContent = r.text;
        mask.appendChild(digit);
        svg.appendChild(mask);
        var shape = numRect(NS, 'currentColor', rx);
        shape.setAttribute('mask', 'url(#' + maskId + ')');
        svg.appendChild(shape);
        return svg;
      }
      el = document.createElement('span');
      el.className = numCls.replace('sugar-icon ', 'sugar-icon sugar-icon--host ') + (className ? ' ' + className : '');
      el.setAttribute('aria-hidden', 'true');
      var n = document.createElement('span');
      n.textContent = r.text;
      el.appendChild(n);
      return el;
    }
    if (r.mode === 'img') {
      el = document.createElement('span');
      el.className = 'sugar-icon sugar-icon--host' + (className ? ' ' + className : '');
      el.setAttribute('aria-hidden', 'true');
      var img = document.createElement('img');
      img.className = 'sugar-icon-img';
      img.src = r.url;
      img.alt = '';
      img.loading = 'lazy';
      img.onerror = function () { el.style.display = 'none'; };
      el.appendChild(img);
      return el;
    }
    if (r.mode === 'lmd') {
      el = document.createElement('span');
      el.className = 'sugar-icon sugar-icon--host' + (className ? ' ' + className : '');
      el.setAttribute('aria-hidden', 'true');
      var anim = document.createElement('sugar-animated-icon');
      anim.className = 'sugar-icon-animated';
      anim.setAttribute('src', r.url);
      el.appendChild(anim);
      if (!customElements.get('sugar-animated-icon') && !document.querySelector('script[src*="sugar-animated-icon"]')) {
        var s = document.createElement('script');
        s.type = 'module';
        s.src = script && script.src ? script.src.replace(/global\.js.*$/, 'sugar-animated-icon.js') : '';
        if (s.src) document.head.appendChild(s);
      }
      return el;
    }
    el = document.createElement('span');
    el.className = 'sugar-icon' + (className ? ' ' + className : '');
    el.style.setProperty('--icon-url', "url('" + r.url + "')");
    el.setAttribute('aria-hidden', 'true');
    // A preload the mask reuses, as icon.liquid does: WebKit downloads an <img>
    // a second time for the mask. It also hides the icon when the file is missing.
    var probe = document.createElement('link');
    probe.rel = 'preload';
    probe.as = 'image';
    probe.crossOrigin = 'anonymous';
    probe.href = r.url;
    probe.onerror = function () { el.style.display = 'none'; };
    el.appendChild(probe);
    return el;
  }

  window.SugarIcon = { base: BASE, resolve: resolve, create: create };
})();
